import { isEmpty } from 'ramda/'

import EmptyWarn from 'app/common/layouts/EmptyWarn'
import Loading from 'app/common/components/Loader'

import DishesKitSimple from './DishesKitSimple'
import useOrgsKitsSimple from './useOrgsKitsSimple'


type Props = {
  orgID: string
}

const KitsListSimple = ({ orgID }: Props) => {
  const [items, loading, { restore }] = useOrgsKitsSimple(orgID)
  const nothing = isEmpty(items)

  if (loading && nothing) {
    return (
      <Loading />
    )
  }

  if (nothing) {
    return (
      <EmptyWarn>
        {'Нет комплектов в текущем подразделе'}
      </EmptyWarn>
    )
  }

  return (
    <>
      {items.map(({ id, title, cost, lastChange }) => (
        <DishesKitSimple
          key={id}
          orgId={parseInt(orgID, 10)}
          id={id}
          title={title}
          cost={cost}
          lastChange={lastChange}
          onRestore={restore}
          loading={loading}
        />
      ))}
    </>
  )
}

export default KitsListSimple
